import { useViewer } from "@/hooks/use-viewer";
import { buildRastrPurchaseHref } from "@/lib/buildRastrPurchaseHref";
/** Every purchase CTA reads the same already-hydrated viewer descriptor. */
export function useRastrPurchaseHref(purchaseUrl: string | null | undefined) {
  return buildRastrPurchaseHref(purchaseUrl, useViewer().clickTracking);
}
